import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { toPascalCase } from '@cli-utils/text.js'
import { renderBuildDefaultValueFromSyncFunctionsRenderer } from '@next-adapter/templates/renderers/generators/form/form-shared/build-default-value-from-sync-functions.js'
import { collectDefaultValueFromTargets } from './collect-default-value-from-targets.js'
import { defaultValueFromHandlerName } from './default-value-from-handler-name.js'

export function buildDefaultValueFromSyncFunctions(
  fields: SchemaField[],
  options: { slugValueHelperName?: string } = {}
): string {
  const mappings = new Map<string, string[]>()
  for (const target of collectDefaultValueFromTargets(fields)) {
    const targets = mappings.get(target.sourceName) ?? []
    targets.push(target.name)
    mappings.set(target.sourceName, targets)
  }

  return Array.from(mappings.entries())
    .map(([sourceName, targetNames]) => {
      const targetSync = targetNames
        .map((targetName) => {
          const currentValueName = `current${toPascalCase(targetName)}`
          const nextValueExpression =
            targetName === 'slug' && options.slugValueHelperName
              ? `${options.slugValueHelperName}(nextValue)`
              : 'nextValue'
          const previousValueExpression =
            targetName === 'slug' && options.slugValueHelperName
              ? `${options.slugValueHelperName}(previousValue)`
              : 'previousValue'
          const canSyncExpression =
            targetName === 'slug' && options.slugValueHelperName ? '!initialData && ' : ''
          return renderBuildDefaultValueFromSyncFunctionsRenderer({
            kind: 'renderBuildDefaultValueFromSyncFunctionsGeneratedValueTemplate',
            props: {
              currentValueName: currentValueName,
              targetName: targetName,
              canSyncExpression: canSyncExpression,
              previousValueExpression: previousValueExpression,
              nextValueExpression: nextValueExpression
            }
          })
        })
        .join('\n')

      return renderBuildDefaultValueFromSyncFunctionsRenderer({
        kind: 'renderBuildDefaultValueFromSyncFunctionsPreviousValueTemplate',
        props: {
          defaultValueFromHandlerName: defaultValueFromHandlerName(sourceName),
          sourceName: sourceName,
          targetSync: targetSync
        }
      })
    })
    .join('\n\n')
}
